import React from 'react';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {StatusField} from '@views/checklists/fields/status_settings/StatusField';

export function ChangeToField(props: IListColumnProps) {
    return <StatusField {...props} actualName="change_to"/>;
}
